/**
 * Event Interest Button bootstrap
 *
 * Initializes the interest button by attaching event listeners, triggering the state sync,
 * and updating all the interest button states on the page.
 */

import { createInterestApi, fetchAndApplyStatus } from "./interest-status.js";
import {
  applyStatusesToPage,
  attachListeners,
  collectEventIds,
  collectInstanceIds,
} from "./interest-button-dom.js";
import { onDomReady } from "../../../assets/javascripts/utils.js";

onDomReady(() => {
  const api = createInterestApi();
  attachListeners(api);

  if (!api.getCurrentUserId()) {
    return;
  }

  const instanceIds = collectInstanceIds();
  const eventIds = collectEventIds();
  const cached = api.readCache();

  if (cached?.instances || cached?.events) {
    applyStatusesToPage(cached.instances ?? {}, cached.events ?? {});
  }

  fetchAndApplyStatus(instanceIds, eventIds, applyStatusesToPage);
});
